import { Component } from '@angular/core';

@Component({
  selector: 'app-pantalla-carga',
  imports: [],
  templateUrl: './pantalla-carga.component.html',
  styleUrl: './pantalla-carga.component.scss'
})
export class PantallaCargaComponent {

}
